import { render, staticRenderFns } from "./CsrContent1.vue?vue&type=template&id=2088d356&scoped=true"
import script from "./CsrContent1.vue?vue&type=script&lang=js"
export * from "./CsrContent1.vue?vue&type=script&lang=js"
import style0 from "./CsrContent1.vue?vue&type=style&index=0&id=2088d356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088d356",
  null
  
)

export default component.exports